import Vue from 'vue'
import { clearToken, getToken, setToken } from '../api/request'
import { queryLoginStatus } from '../api/auth'

export const authBus = new Vue({
  data() {
    return { isLoggedIn: Boolean(getToken()), user: null }
  },
  methods: {
    login(authData) {
      if (authData && authData.tokenValue) setToken(authData.tokenValue)
      this.user = authData ? authData.user : null
      this.isLoggedIn = Boolean(this.user)
    },
    setUser(user) {
      this.user = user
      this.isLoggedIn = Boolean(user)
    },
    logout() {
      clearToken()
      this.user = null
      this.isLoggedIn = false
    },
    async syncLoginStatus() {
      if (!getToken()) {
        this.logout()
        return false
      }
      try {
        const { data } = await queryLoginStatus()
        if (data.code === 200 && data.data && data.data.loggedIn && data.data.user) {
          this.setUser(data.data.user)
          return true
        }
      } catch (error) {
        // Invalid and expired tokens are handled as logged out locally.
      }
      this.logout()
      return false
    }
  }
})
